module.exports = __webpack_public_path__ + "img/icon274.4932f262.png";